
<template>
  <div>
    <div class="goods-details-cont">
      <div v-for="(item, index) in detailData.filter(item => !item.isHide)" :key="index">
        <span>{{ item.label }}：</span>
        <p>{{ item.value }}</p>
      </div>
      <!-- <template v-if="productType === 'RAW_MATERIAL'">
        <div v-for="item in fileDetail" :key="item.label" >
          <span>{{ item.label }}：</span>
          <p v-for="(el, index) in item.value" :key="index">
            <el-popover
              placement="top"
              trigger="hover"
              popper-class="popper--upload-class popper--upload-class-detail"
              :disabled="popoverDisabled"
              >
                <div>
                  <el-button type="text" icon="el-icon-view" @click="previewBtn(el)">预览</el-button>
                  <el-button type="text" icon="el-icon-download" @click="downloadFile(el)">下载</el-button>
                </div>
                <p slot="reference">
                  <i class="el-icon-document"></i>
                  {{ el.name }}
                </p>
            </el-popover>
          </p>
        </div>
      </template> -->
    </div>
    <div style="clear: both"></div>
    <div class="file-list">
      附件：
      <p class="file-list-item">
        <span
          v-for="(el, index) in fileList"
          :key="index"
        >
        <el-popover
          placement="top"
          trigger="hover"
          popper-class="popper--upload-class popper--upload-class-detail"
          :disabled="popoverDisabled"
          >
            <div>
              <el-button type="text" icon="el-icon-view" @click="previewBtn(el)">预览</el-button>
              <el-button type="text" icon="el-icon-download" @click="downloadFile(el)">下载</el-button>
            </div>
            <p slot="reference">
              <i class="el-icon-document"></i>
              {{ el.name }}
            </p>
        </el-popover>
        </span>
      </p>
    </div>
    <div v-if="productType === 'RAW_MATERIAL'">
      <h4 style="margin-left: 125px;">供应商附件</h4>
        <div style="margin-left: 145px;" v-for="item in fileDetail" :key="item.label">
          <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
            <span style="width: 145px;line-height: 30px;">{{ item.label }}：</span>
            <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
              <span style="margin-right: 5px" v-for="(el, index) in item.value" :key="index">
                <el-popover
                  placement="top"
                  trigger="hover"
                  popper-class="popper--upload-class popper--upload-class-detail"
                  :disabled="popoverDisabled"
                  >
                    <div>
                      <el-button type="text" icon="el-icon-view" @click="previewBtn(el)">预览</el-button>
                      <el-button type="text" icon="el-icon-download" @click="downloadFile(el)">下载</el-button>
                    </div>
                    <p slot="reference">
                      <i class="el-icon-document"></i>
                      {{ el.name }}
                    </p>
                </el-popover>
              </span>
            </div>
          </div>
        </div>
    </div>
    <!-- 预览文件 -->
    <previewFileDialog :type="fileType" :url="fileUrl" ref="previewDialog" />
    <!-- 详情弹窗 -->
    <OutsideSampleOperationLogDialog v-if="showLog" ref="sampleOperationLogDialog" :id="id" :detailId="detailId" />
  </div>
</template>
<script>
import download from '@/utils/download';
import previewFileDialog from '@/components/previewFileDialog';
import OutsideSampleOperationLogDialog from '@/components/OutsideSampleOperationLogDialog';

export default {
  components: { previewFileDialog, OutsideSampleOperationLogDialog },
  props: {
    id: {
      type: String,
      default: ''
    },
    detailId: {
      type: String,
      default: ''
    },
    showLog: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    detailData: [
      {
        label: '品类',
        prop: 'productTypeName',
      },
      {
        label: '产品名称',
        prop: 'productName',
      },
      {
        label: '数量',
        prop: 'num',
      },
      {
        label: '单位',
        prop: 'unit',
      },
      {
        label: '需求品牌',
        prop: 'demandBrandName',
      },
      {
        label: '需求人员',
        prop: 'demandStaffName',
      },
      {
        label: '要求到样时间',
        prop: 'askArrivalTime',
      },
      {
        label: '成本范围',
        prop: 'costRange',
      },
      {
        label: '用途',
        prop: 'purpose',
      },
      {
        label: '包材要求',
        prop: 'packagingMaterialRequirement',
        isHide: false
      },
      {
        label: '料体要求',
        prop: 'materialRequirement',
        isHide: false
      },
      {
        label: '其它要求',
        prop: 'otherRequirement',
      },
      {
        label: '对标竞品',
        prop: 'bidding',
      },
      {
        label: '特殊备注',
        prop: 'specialRemark',
      },
      {
        label: '上级领导审批',
        prop: 'leadApprovalName',
        isHide: false
      }
    ],
    fileList: [],
    fileType: '',
    fileUrl: '',
    popoverDisabled: false,
    listData: {},
    fileDetail: [
      { label: 'SPEC/TDS', field: 'specTdsAttachmentList' },
      { label: 'MSDS', field: 'msdsAttachmentList' },
      { label: 'COA', field: 'coaAttachmentList' },
      { label: '附件14', field: 'file14AttachmentList' },
      { label: '原料介绍及应用资料', field: 'rawMaterialsAppAttachmentList' },
    ],
    productType: ''
  }),
  watch: {
    id() {
      this.getDetail();
    }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      if(!this.id) return;
      this.$http.outsideSampleManage
        .getOrderDetail(this.id)
        .then(result => {
          this.productType = result.data.productType;
          this.fileDetail = this.fileDetail.map(item => ({
            ...item,
            value: result.data[item.field]
          }))
          this.detailData = this.detailData.map(item => {
            item.value = result.data[item.prop];
            return item;
          });
          const type = result.data.productType;
          const packagingMaterialRequirement = this.detailData.find(item => item.prop === 'packagingMaterialRequirement')
          const leadApprovalName = this.detailData.find(item => item.prop === 'leadApprovalName')
          const materialRequirement = this.detailData.find(item => item.prop === 'materialRequirement')
          packagingMaterialRequirement.isHide = false;
          materialRequirement.isHide = false;
          leadApprovalName.isHide = false;
          // 如果品类选中膜布，不显示包材要求和料体要求；
          if(type === 'MEMBRANE_CLOTH') {
            packagingMaterialRequirement.isHide = true;
            materialRequirement.isHide = true;
            leadApprovalName.isHide = true;
          }
          // 如果品类选中原料，不显示包材要求；
          if(type === 'RAW_MATERIAL') {
            packagingMaterialRequirement.isHide = true;
          }
          // 如果品类选中包材，不显示料体要求
          if(type === 'PACKING_MATERIAL') {
             materialRequirement.isHide = true;
             leadApprovalName.isHide = true;
          }
          if(type === 'ODM') {
             leadApprovalName.isHide = true;
          }
          this.fileList = result.data.urlList || [];
          this.$emit('return-sample-data', result.data);
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
      this.$refs.sampleOperationLogDialog && this.$refs.sampleOperationLogDialog.getDetail();
    },
    // 下载模板文件
    downloadFile({name, url}) {
      download(url, name);
    },
    // 预览文件
    previewBtn({name, url}) {
      // 隐藏popover弹窗
      this.popoverDisabled = true;
      setTimeout(() => {
        this.popoverDisabled = false;
      }, 500);
      const fileExtend = name.substring(name.lastIndexOf('.')).toLowerCase();
      const type = ['.png','.jpeg','.jpg'].includes(fileExtend) ? 'img' : 'file';
      this.fileUrl = url;
      this.fileType = fileExtend.indexOf('pdf') > -1 ? 'pdf' : type;
      this.$refs.previewDialog.dialogVisible = true;
    }
  },
};
</script>
<style lang="less" scoped>
.goods-details-cont {
  float: right;
  width: calc(100% - 120px);
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  color: #666;
  & > div {
    width: 48%;
    padding: 5px;
  }
  span {
    float: left;
    width: 150px;
  }
  p {
    line-height: 20px;
    word-break: break-all;
  }
}
.file-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 5px 0 10px 125px;
  font-size: 14px;
  color: #666;
  p {
    padding-left: 30px;

  }
  span {
    display: block;
    line-height: 25px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
/* .popper--upload-class-detail {
  margin-bottom: 0 !important;
} */
</style>